import { SyncErrorClassification } from '../../../../actions/plaid/authActions'

export enum PlaidConnectionStatus {
  Inactive = 'inactive',
  Disconnected = 'disconnected',
  SyncError = 'sync_error',
  LowFrequency = 'low_frequency',
  Healthy = 'healthy',
}

export const derivePlaidConnectionStatus = ({
  isInactive,
  needsReconnection,
  syncErrorClassification,
  noRecentTransactions,
}: {
  isInactive: boolean
  needsReconnection: boolean
  syncErrorClassification: string | null
  noRecentTransactions: boolean
}): PlaidConnectionStatus => {
  if (isInactive) return PlaidConnectionStatus.Inactive
  if (
    needsReconnection ||
    syncErrorClassification === SyncErrorClassification.REAUTH_REQUIRED
  )
    return PlaidConnectionStatus.Disconnected
  if (syncErrorClassification !== null) return PlaidConnectionStatus.SyncError
  if (noRecentTransactions) return PlaidConnectionStatus.LowFrequency
  return PlaidConnectionStatus.Healthy
}
